// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
// For Unauthorization 
export const UNAUTHORIZED_INTENT = "UNAUTHORIZED_INTENT"
// For Sidebar data
export const SIDEBAR_DATA = "SIDEBAR_DATA"
// For Report ID
export const REPORT_ID = "REPORT_ID"
// For Report Data
export const REPORT_DATA = "REPORT_DATA"
// For Report Data
export const REPORT_DATA_MORE = "REPORT_DATA_MORE"
// For Report Data
export const FOLLOW_LIST = "FOLLOW_LIST"
// For Report Data
export const TRIGGER_LIST = "TRIGGER_LIST"
// For Report Data
export const TRIGGER_REPORT = "TRIGGER_REPORT"
// For Report Data
export const NEWS_REPORT = "NEWS_REPORT"
// For Report Data
export const TRACKING_LIST = "TRACKING_LIST"
// For Report Data
export const EMAIL_DATA = "EMAIL_DATA"
// For Report Data
export const FOLLOW_LIST_SETUP = "FOLLOW_LIST_SETUP"
export const INDUSTRY_DATA = "INDUSTRY_DATA"
export const TRIGGER_DATA = "TRIGGER_DATA"
